import { Container } from "./styles";
import mernIcon from "../../assets/mern-icon.webp";
import mongodbIcon from "../../assets/mongo.png";
import expressIcon from "../../assets/expressyellow-icon.png";
import reactIcon from "../../assets/react-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactNativeIcon from "../../assets/ReactNative1.png";
import djangoIcon from "../../assets/django1.png";
import pythonIcon from "../../assets/python-icon.svg";
import JupyterIcon from "../../assets/jupyter-icon.svg";
import NextIcon from "../../assets/next.png";
import typescriptIcon from "../../assets/typescript-icon.svg";
import excelIcon from "../../assets/excel1.png";
import sqlIcon from "../../assets/sql.png";
import jsIcon from "../../assets/js-icon.svg";
import mysqlIcon from "../../assets/mysql.png";
import tailwindIcon from "../../assets/tailwind-icon.svg";
import reactexpoIcon from "../../assets/reactexpo.png";
import sanityIcon from "../../assets/sanity.png";
import appwriteIcon from "../../assets/appwrite.png";
import powerbiIcon from "../../assets/powerbi.png";
import tableauIcon from "../../assets/tableu.png";
import benfelix1 from "../../assets/benfelix1.jpg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>🚀 About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hi there! I'm Benfelix Omondi Ogwari — a passionate and enthusiastic MERN Full-Stack Web Developer and Mobile App Developer dedicated to crafting custom, responsive, and user-friendly digital experiences. My technical stack includes JavaScript, MongoDB, Express.js, React.js, Node.js, Next.js, Django, React Native, ReactNative Expo, and Tailwind CSS. With this diverse toolkit, I have the capability to bring any web or mobile app vision to life, from back-end logic to seamless front-end design.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
            In addition to web and mobile app development, I’m also skilled in Data Science and Data Analysis, with hands-on experience using Python, Excel, PowerBi, Tableau and SQL to extract insights, solve data-driven problems, and support smarter decision-making.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            💼 Let’s Collaborate!<br/>
            Whether you need a powerful new website, a custom mobile app, or a skilled data analyst to make sense of your data, I’d love to connect and explore how I can help. Let’s turn your digital ideas and data-driven goals into reality—together.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.10 * 1000}>
              <img src={mernIcon} alt="MERN1" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={mongodbIcon} alt="Mongodb" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={expressIcon} alt="Express.js" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={reactIcon} alt="React.js" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={nodeIcon} alt="Node.js" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.20 * 1000}>
              <img src={reactNativeIcon} alt="React Native" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.22 * 1000}>
              <img src={djangoIcon} alt="Django" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.24 * 1000}>
              <img src={pythonIcon} alt="Python" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.26 * 1000}>
              <img src={JupyterIcon} alt="Jupyter Notebook" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.28 * 1000}>
              <img src={NextIcon} alt="Next.js" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.30 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.32 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.34 * 1000}>
              <img src={mysqlIcon} alt="MySQL" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.36 * 1000}>
              <img src={tailwindIcon} alt="Tailwind CSS" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.38 * 1000}>
              <img src={reactexpoIcon} alt="React Native Expo" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.40 * 1000}>
              <img src={sanityIcon} alt="Sanity Io" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.42 * 1000}>
              <img src={appwriteIcon} alt="Appwrite" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.44 * 1000}>
              <img src={sqlIcon} alt="SQL" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.46 * 1000}>
              <img src={tableauIcon} alt="Tableau" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.48 * 1000}>
              <img src={powerbiIcon} alt="Power BI" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.50 * 1000}>
              <img src={excelIcon} alt="Excel" />" 
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.15 * 1000}>
          <img src={benfelix1} alt="Benfelix" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
